import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface AcessibilidadeState {
  fontSize: number;
  highContrast: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AcessibilidadeService {
  private readonly CHAVE_TAMANHO_FONTE = 'font-size-level';
  private readonly CHAVE_CONTRASTE = 'high-contrast';

  private state = new BehaviorSubject<AcessibilidadeState>({
    fontSize: 0,
    highContrast: false
  });

  public state$ = this.state.asObservable();

  constructor() {
    this.carregarConfiguracoes();
    this.aplicarConfiguracoes();
  }

  private carregarConfiguracoes(): void {
    const fontSize = parseInt(localStorage.getItem(this.CHAVE_TAMANHO_FONTE) || '0', 10);
    const highContrast = localStorage.getItem(this.CHAVE_CONTRASTE) === 'true';

    this.state.next({ fontSize, highContrast });
  }

  private salvarConfiguracoes(): void {
    const currentState = this.state.value;
    localStorage.setItem(this.CHAVE_TAMANHO_FONTE, currentState.fontSize.toString());
    localStorage.setItem(this.CHAVE_CONTRASTE, currentState.highContrast.toString());
  }

  private aplicarConfiguracoes(): void {
    const currentState = this.state.value;
    const body = document.body;

    body.classList.remove('font-size-small', 'font-size-normal', 'font-size-large');
    body.classList.remove('high-contrast');

    if (currentState.fontSize === 1) {
      body.classList.add('font-size-large');
    } else if (currentState.fontSize === -1) {
      body.classList.add('font-size-small');
    } else {
      body.classList.add('font-size-normal');
    }

    if (currentState.highContrast) {
      body.classList.add('high-contrast');
    }
  }

  aumentarFonte(): void {
    const currentState = this.state.value;
    if (currentState.fontSize < 1) {
      this.state.next({ ...currentState, fontSize: currentState.fontSize + 1 });
      this.salvarConfiguracoes();
      this.aplicarConfiguracoes();
    }
  }

  diminuirFonte(): void {
    const currentState = this.state.value;
    if (currentState.fontSize > -1) {
      this.state.next({ ...currentState, fontSize: currentState.fontSize - 1 });
      this.salvarConfiguracoes();
      this.aplicarConfiguracoes();
    }
  }

  resetarTamanhoFonte(): void {
    const currentState = this.state.value;
    this.state.next({ ...currentState, fontSize: 0 });
    this.salvarConfiguracoes();
    this.aplicarConfiguracoes();
  }

  habilitarContraste(): void {
    const currentState = this.state.value;
    this.state.next({ ...currentState, highContrast: !currentState.highContrast });
    this.salvarConfiguracoes();
    this.aplicarConfiguracoes();
  }

  pularParaElemento(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.focus();
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
